module.exports = __webpack_public_path__ + "img/Tech - Khloe Faria-1.bfd441ad.png";